import React from 'react';
import { Container, Row, Col } from 'reactstrap';
import style from './style.module.css';

const data = [
  {
    title: 'BÀI TẬP MỚI',
    context: [
      { exercise: 'Bài tập 6', time: '29/12/2021' },
      { exercise: 'Bài tập 4', time: '29/12/2021' },
      { exercise: 'Bài tập 3', time: '29/12/2021' },
    ],
  },
  { title: 'BÀI TẬP GIỚI HẠN', context: [{ exercise: 'Bài tập 4', time: '11/12/2021' }] },
  {
    title: 'BÀI TẬP ĐÃ LÀM',
    context: [
      { exercise: 'Bài tập 4', time: '23/12/2021' },
      { exercise: 'Bài tập 3', time: '23/12/2021' },
      { exercise: 'Bài tập 2', time: '23/12/2021' },
      { exercise: 'Bài tập 1', time: '23/12/2021' },
    ],
  },
  { title: 'BÀI KIỂM TRA TIẾN ĐỘ', context: [{ exercise: 'Bài tập 2', time: '24/12/2021' }] },
];
function index() {
  return (
    <div style={{ width: '100%' }}>
      <Row style={{ justifyContent: 'center' }}>
        {data.map((x, i) => (
          <Col xs={2} style={{ padding: 0, marginTop: 20 }} key={`index${i}`}>
            <div style={{ border: '1px solid #d1d4d4', margin: 5 }}>
              <div style={{ height: 40, background: '#00b4cb', color: '#fff', padding: '0 10px', display: 'flex', alignItems: 'center' }}>
                <div style={{ fontWeight: 600 }}>{x.title}</div>
              </div>
              <div style={{ height: 250 }}>
                <table className={style.customers}>
                  <tr>
                    <th>Bài tập</th>
                    <th>Thời gian</th>
                  </tr>
                  {x.context.map((value) => (
                    <tr>
                      <td>{value.exercise}</td>
                      <td>{value.time}</td>
                    </tr>
                  ))}
                </table>
              </div>
            </div>
          </Col>
        ))}
      </Row>
    </div>
  );
}
export default index;
